import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './UpdateManuScriptForm.css';

import { useNavigate } from 'react-router-dom';

import UttamKalakarHeader from './UttamKalakarHeader';
import UttamKalakarFooter from './UttamKalakarFooter';

const UpdateManuScriptForm = () => {
    const [formValues, setFormValues] = useState({
        articletype: '',
        title: '',
        userId: ''
    });

    const navigate = useNavigate();

    useEffect(() => {
        const loggedInUserId = sessionStorage.getItem('userId');

        if (loggedInUserId) {
            setFormValues((prevValues) => ({
                ...prevValues,
                userId: loggedInUserId
            }));
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value
        }));
    };

    const handleSave = async () => {
        if (!formValues.articletype || !formValues.title) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Fields',
                text: 'Please fill all required fields',
            });
            return;
        }

        try {
            const response = await axios.post(
                'https://nrdruhs.in/updatemanuscriptform',
                formValues
            );

            console.log('Form data saved:', response.data);

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Manuscript data updated successfully',
            }).then(() => {
                navigate('/articleupload');
            });

        } catch (error) {
            console.error('Error saving form data:', error);

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while updating manuscript data',
            });
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (window.scrollY > 0) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            <UttamKalakarHeader />

            <div className="container mt-5" style={{ marginTop: 30 }}>
                <h3
                    className="mt-2"
                    style={{
                        textAlign: 'center',
                        padding: 15,
                        fontWeight: 'bold',
                        backgroundColor: '#ff2056',
                        color: 'white'
                    }}
                >
                    Step 2
                </h3>

                <br />

                <h2
                    style={{
                        textAlign: 'center',
                        marginBottom: 30,
                        fontWeight: 'bold',
                        fontSize: 24
                    }}
                >
                    UPDATE MANUSCRIPT FORM
                </h2>

                <form className="col-md-8 mx-auto">

                    <div className="mb-3">
                        <strong>
                            <label htmlFor="articletype" className="form-label">
                                Article Type
                            </label>
                        </strong>

                        <select
                            className="form-control"
                            id="articletype"
                            name="articletype"
                            value={formValues.articletype}
                            onChange={handleChange}
                        >
                            <option value="">Select Article Type</option>
                            <option value="Thesis">Thesis</option>
                            <option value="Original Research">Original Research</option>
                            <option value="Review">Review</option>
                            <option value="Case Report">Case Report</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <strong>
                            <label htmlFor="title" className="form-label">
                                Title
                            </label>
                        </strong>
                        <input
                            type="text"
                            className="form-control"
                            id="title"
                            name="title"
                            value={formValues.title}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="mb-3" style={{ textAlign: 'center', padding: 30 }}>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </div>

                </form>
            </div>

            <UttamKalakarFooter />
        </div>
    );
};

export default UpdateManuScriptForm;